export const events = {
  newCategoryPressed: 'Time settings new category pressed',
}
